import { BreadcrumbsProvider } from '@dealstack/frontend/shared/components/Breadcrumbs/useBreadcrumbs';
import { headerHeight } from '@dealstack/frontend/shared/mechanism/styleguide/GlobalStyling';
import styled from 'styled-components';
import { Header } from '@dealstack/frontend/shared/components/Header/Header';

interface Props {
	className?: string;
	children?: React.ReactNode;
	defaultProtectedRoute: string;
	isInvestorApp?: boolean;
	investmentsDropdown?: React.ReactNode;
	hideOverflowX?: boolean;
}

const MainLayout = ({
	className,
	isInvestorApp,
	children,
	defaultProtectedRoute,
	investmentsDropdown,
}: Props) => {
	return (
		<div className={className}>
			<BreadcrumbsProvider>
				<Header
					defaultProtectedRoute={defaultProtectedRoute}
					isInvestorApp={isInvestorApp}
					investmentsDropdown={investmentsDropdown}
				/>
				<ContentWrapper>{children}</ContentWrapper>
			</BreadcrumbsProvider>
		</div>
	);
};

export const ContentWrapper = styled.div``;

const Styled = styled(MainLayout)`
	height: 100vh;
	display: flex;
	flex-direction: column;
	max-width: 100vw;
	// Note: overflow-x seems to disable window scroll event listeners
	${({ hideOverflowX = true }) => hideOverflowX && 'overflow-x: hidden;'}

	${ContentWrapper} {
		display: flex;
		flex-direction: column;
		flex-grow: 1;
		height: calc(100vh - ${headerHeight});
	}
`;

export { Styled as MainDesktopLayout };
